module.exports = __webpack_public_path__ + "static/img/qc2.3a3c192.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/pic/qc2.jpg
// module id = uvGL
// module chunks = 11